"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _getPrototypeOf = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _set = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/set");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContentShareConstants_1 = require("../contentsharecontroller/ContentShareConstants");

var VideoPreference_1 = require("./VideoPreference");

var VideoPreferences_1 = require("./VideoPreferences");

var VideoPriorityBasedPolicy_1 = require("./VideoPriorityBasedPolicy");

var VideoAdaptiveProbePolicy = /*#__PURE__*/function (_VideoPriorityBasedPo) {
  _inherits(VideoAdaptiveProbePolicy, _VideoPriorityBasedPo);

  var _super = _createSuper(VideoAdaptiveProbePolicy);

  function VideoAdaptiveProbePolicy(logger) {
    var _this;

    _classCallCheck(this, VideoAdaptiveProbePolicy);

    _this = _super.call(this, logger);
    _this.logger = logger;

    _set(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "shouldPauseTiles", false, _assertThisInitialized(_this), true);

    _this.videoPreferences = undefined;
    return _this;
  }

  _createClass(VideoAdaptiveProbePolicy, [{
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "reset", this).call(this);

      _set(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "shouldPauseTiles", false, this, true);

      this.videoPreferences = undefined;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      _get(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "updateIndex", this).call(this, videoIndex);

      var newPreferences = VideoPreferences_1.VideoPreferences.prepare();
      var containsContent = false;
      var remoteInfos = videoIndex.remoteStreamDescriptions(); // If there is active content then set that as high priority, and the rest at lower

      var _iterator = _createForOfIteratorHelper(remoteInfos),
          _step;

      try {
        var _loop = function _loop() {
          var info = _step.value;

          // I don't know why we need to do this duplicate check.
          if (!newPreferences.some(function (preference) {
            return preference.attendeeId === info.attendeeId;
          })) {
            // For now always subscribe to content even if higher bandwidth then target
            if (info.attendeeId.endsWith(ContentShareConstants_1.default.Modality)) {
              newPreferences.add(new VideoPreference_1.default(info.attendeeId, 1));
              containsContent = true;
            } else {
              newPreferences.add(new VideoPreference_1.default(info.attendeeId, 2));
            }
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (containsContent) {
        this.videoPreferences = newPreferences.build();
        this.videoPreferencesUpdated = true;
      } else {
        this.videoPreferences = undefined;
      }
    }
    /**
     * [[VideoAdaptiveProbePolicy]] does not allow setting video preferences and this function
     * will be a no-op.  Please use [[VideoPriorityBasedPolicy]] directly if you would like to set
     * preferences.
     */

  }, {
    key: "chooseRemoteVideoSources",
    value: function chooseRemoteVideoSources(_preferences) {
      this.logger.error('chooseRemoteVideoSources should not be called by VideoAdaptiveProbePolicy');
      return;
    }
  }]);

  return VideoAdaptiveProbePolicy;
}(VideoPriorityBasedPolicy_1.default);

exports.default = VideoAdaptiveProbePolicy;